import { hasImage } from '$tablet-app/src/app/images/actions';
import RecordImage from '$tablet-app/src/app/images/components/RecordImage';
import { RecordWithImageFields } from '$tablet-app/src/app/images/types';
import React, { FC } from 'react';
import { ImageStyle, StyleProp, ViewStyle } from 'react-native';
import styled from 'styled-components/native';
import { ContactPlaceholder } from './ContactPlaceholder';

interface Props {
  contact: RecordWithImageFields & { name: string };

  style?: StyleProp<ViewStyle>;
}

const ContactAvatar: FC<Props> = ({ contact, style }) => {
  const showImage = hasImage(contact);

  return showImage ? (
    <Image style={style as ImageStyle} record={contact} />
  ) : (
    <ContactPlaceholder
      initial={contact.name[0]}
      height={55}
      width={55}
      style={style}
    />
  );
};

const Image = styled(RecordImage)`
  height: 55px;
  width: 55px;
  border-radius: 20px;
`;

export default ContactAvatar;
